import { Box } from '@factorialco/deprecated-design-system'
import { isEmpty } from 'lodash'

import { observer } from 'mobx-react'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import Publish from 'modules/shift_management/components/ShiftManagement/Layout/Actions/Publish'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useSelectionState } from 'modules/shift_management/hooks/useSelection'

import AddShiftButton from './AddShiftButton'
import ClearSelectionButton from './ClearSelectionButton'
import CopyPeriodButton from './CopyPeriodButton'
import CopyShiftButton from './CopyShiftButton'
import DeleteButton from './DeleteButton'
import EditShiftsButton from './EditShiftButton'
import ShowCoverageSectionButton from './ShowCoverageSectionButton'

interface Props {
  hasNoneShiftManagementPlanning?: boolean
  disabled?: boolean
  setShowCoverageSection: (showCoverageSection: boolean) => void
  showCoverageSection?: boolean
  contractVersions: ContractVersions
  hasTimeOffModule: boolean
}

const ShiftActionsBar = ({
  hasNoneShiftManagementPlanning,
  disabled,
  setShowCoverageSection,
  showCoverageSection,
  contractVersions,
  hasTimeOffModule,
}: Props) => {
  const [{ view }] = useSchedule()
  const { isEnabled: isSelectionEnabled, shifts: selectedShifts } = useSelectionState()
  const [{ canUseCoverageView, canUseCopySchedulePeriod }] = useEnabledFeatures()

  const showCoverageSectionButton = view.isByEmployees && view.isWeekly
  const shifts = Object.values(selectedShifts)

  return (
    <Box flexDirection="row" gap="s8" alignItems="center">
      {showCoverageSectionButton && (
        <Box
          border={{ right: { width: 's1', color: 'grey400', style: 'solid' } }}
          paddingRight="s8"
        >
          <ShowCoverageSectionButton
            setShowCoverageSection={setShowCoverageSection}
            showCoverageSection={showCoverageSection}
            hasNoneShiftManagementPlanning={disabled}
            hasCoverageView={canUseCoverageView}
          />
        </Box>
      )}
      {!isSelectionEnabled && view.isWeekly && !canUseCopySchedulePeriod && (
        <CopyShiftButton
          disabled={hasNoneShiftManagementPlanning}
          contractVersions={contractVersions}
        />
      )}
      {isSelectionEnabled && <ClearSelectionButton />}
      {isSelectionEnabled && !isEmpty(shifts) && (
        <EditShiftsButton contractVersions={contractVersions} />
      )}
      <AddShiftButton
        disabled={hasNoneShiftManagementPlanning}
        contractVersions={contractVersions}
        hasTimeOffModule={hasTimeOffModule}
      />
      {canUseCopySchedulePeriod && <CopyPeriodButton disabled={hasNoneShiftManagementPlanning} />}
      <DeleteButton disabled={hasNoneShiftManagementPlanning} contractVersions={contractVersions} />
      <Publish contractVersions={contractVersions} />
    </Box>
  )
}

export default observer(ShiftActionsBar)
